import { computed, useCssModule } from "vue";
import { g as getUid } from "./index-Df_FM1j-.js";
import "./index-CgZzOVq6.js";
import { u as useListeners } from "./index-Ca8wHgNc.js";
import { u as useDataTestIdProp } from "./index-BNd8MWnO.js";
import "./index-vzP2cezV.js";
import { isVue3 } from "vue-demi";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { u as useVModel } from "./index-BJV0_gaH.js";
import { u as useDisabledProp } from "./index-DKxr0Yto.js";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-VvYS6rEj.js";
function isObject(value) {
  const type = typeof value;
  return !!value && (type === "object" || type === "function");
}
function useItemsCustomKeysProps(options = {}) {
  const DEFAULT_OPTIONS = {
    itemsPropName: "items",
    itemTextKey: "text",
    itemValueKey: "value"
  };
  const {
    itemsPropName = DEFAULT_OPTIONS.itemsPropName,
    itemTextKey = DEFAULT_OPTIONS.itemTextKey,
    itemValueKey = DEFAULT_OPTIONS.itemValueKey,
    validator = (item) => item
  } = options;
  function createItemsCustomKeysProps2() {
    return {
      itemTextKey: {
        type: String,
        default: itemTextKey,
        validator: (key) => !!key
      },
      itemValueKey: {
        type: String,
        default: itemValueKey,
        validator: (key) => !!key
      }
    };
  }
  function createItemObject(item, props = DEFAULT_OPTIONS) {
    const isItemAnObject = isObject(item);
    const itemValue = isItemAnObject ? item[DEFAULT_OPTIONS.itemValueKey] ?? item[props.itemValueKey] : item;
    const itemText = isItemAnObject ? item[DEFAULT_OPTIONS.itemTextKey] ?? item[props.itemTextKey] : item;
    const itemObject = {
      [DEFAULT_OPTIONS.itemTextKey]: itemText,
      [DEFAULT_OPTIONS.itemValueKey]: itemValue
    };
    if ((props == null ? void 0 : props.itemTextKey) && DEFAULT_OPTIONS.itemTextKey !== props.itemTextKey) {
      itemObject[props.itemTextKey] = itemText;
    }
    if ((props == null ? void 0 : props.itemValueKey) && DEFAULT_OPTIONS.itemValueKey !== props.itemValueKey) {
      itemObject[props.itemValueKey] = itemValue;
    }
    return itemObject;
  }
  function itemHasCorrectKeys(item, props = DEFAULT_OPTIONS) {
    if (!isObject(item)) {
      return false;
    }
    const textKeyExists = DEFAULT_OPTIONS.itemTextKey in item;
    const valueKeyExists = DEFAULT_OPTIONS.itemValueKey in item;
    const customTextKeyExists = props.itemTextKey in item;
    const customValueKeyExists = props.itemValueKey in item;
    return textKeyExists && valueKeyExists && customTextKeyExists && customValueKeyExists;
  }
  function getItemsWithDefaultKeys2(props) {
    function setItemWithDefaultKeys(item) {
      const itemWithDefaultKeys = item;
      if (validator(itemWithDefaultKeys)) {
        if (!(itemWithDefaultKeys == null ? void 0 : itemWithDefaultKeys[DEFAULT_OPTIONS.itemTextKey])) {
          itemWithDefaultKeys[DEFAULT_OPTIONS.itemTextKey] = itemWithDefaultKeys == null ? void 0 : itemWithDefaultKeys[props.itemTextKey];
        }
        if (!(itemWithDefaultKeys == null ? void 0 : itemWithDefaultKeys[DEFAULT_OPTIONS.itemValueKey])) {
          itemWithDefaultKeys[DEFAULT_OPTIONS.itemValueKey] = itemWithDefaultKeys == null ? void 0 : itemWithDefaultKeys[props.itemValueKey];
        }
      }
      return itemWithDefaultKeys;
    }
    const computedItems = computed(() => {
      return props[itemsPropName].map((item) => {
        return setItemWithDefaultKeys(item);
      });
    });
    return {
      computedItems
    };
  }
  return {
    DEFAULT_OPTIONS,
    createItemsCustomKeysProps: createItemsCustomKeysProps2,
    getItemsWithDefaultKeys: getItemsWithDefaultKeys2,
    createItemObject,
    itemHasCorrectKeys
  };
}
const { createDisabledProp } = useDisabledProp();
const { createTestIdProp } = useDataTestIdProp();
const { createVModelProp } = useVModel();
const { createItemsCustomKeysProps, getItemsWithDefaultKeys } = useItemsCustomKeysProps();
const baseProps = {
  items: {
    type: Array,
    default: () => []
  },
  name: {
    type: String,
    default: ""
  },
  value: {
    type: [String, Number, Boolean, Array, Object],
    default: ""
  },
  directionRow: {
    type: Boolean,
    default: false
  },
  labelFirst: {
    type: Boolean,
    default: false
  },
  errorMessage: {
    type: String,
    default: ""
  },
  preventFocus: {
    type: Boolean,
    default: false
  },
  disableForm: {
    type: Boolean,
    default: false
  },
  checked: {
    type: [String, Number, Boolean, Array, Object],
    default: false
  },
  ...createDisabledProp(),
  ...createVModelProp([Boolean, Array, String], false),
  ...createTestIdProp(),
  ...createItemsCustomKeysProps()
};
const types = {
  type: {
    type: String,
    default: "checkbox",
    validator: (status) => /^$|checkbox|radio|switch/.test(status)
  }
};
const emits = ["change", "update:modelValue"];
const changeEvent = isVue3 ? emits[1] : emits[0];
const modelPropName = isVue3 ? "modelValue" : "checked";
const model = {
  prop: "checked",
  event: "change"
};
const BaseOption = "_BaseOption_hgop1_1";
const BaseOptionInput = "_BaseOptionInput_hgop1_8";
const isCheckbox = "_isCheckbox_hgop1_8";
const BaseOptionLabel = "_BaseOptionLabel_hgop1_8";
const BaseOptionBox = "_BaseOptionBox_hgop1_11";
const isDisabled = "_isDisabled_hgop1_43";
const BaseOptionText = "_BaseOptionText_hgop1_81";
const isSwitch = "_isSwitch_hgop1_84";
const isRadio = "_isRadio_hgop1_144";
const isLabelFirst = "_isLabelFirst_hgop1_207";
const style0 = {
  BaseOption,
  BaseOptionInput,
  isCheckbox,
  BaseOptionLabel,
  BaseOptionBox,
  isDisabled,
  BaseOptionText,
  isSwitch,
  isRadio,
  isLabelFirst
};
const { setupTestId } = useDataTestIdProp();
const { setupVModel } = useVModel();
const __default__ = {
  name: "SingleInput",
  inheritAttrs: false,
  model
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    ...types,
    ...baseProps
  },
  emits,
  setup(__props, { emit }) {
    const props = __props;
    const $style = useCssModule();
    const uidInput = getUid("input");
    const uidLabel = getUid("label");
    const { formatTestId } = setupTestId(props);
    const { data: checkedValues } = setupVModel(props, emit);
    const typeClass = computed(() => ({
      [$style.isRadio]: props.type === "radio",
      [$style.isSwitch]: props.type === "switch",
      [$style.isCheckbox]: props.type === "checkbox"
    }));
    const directionClass = computed(() => ({
      [$style.isLabelFirst]: props.labelFirst
    }));
    const inputType = computed(() => props.type === "radio" ? "radio" : "checkbox");
    const { v2Listeners } = useListeners(["change"]);
    return { __sfc: true, setupTestId, setupVModel, props, emit, $style, uidInput, uidLabel, formatTestId, checkedValues, typeClass, directionClass, inputType, v2Listeners };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: _setup.$style.BaseOption }, [_setup.inputType === "checkbox" ? _c("input", _vm._g(_vm._b({ directives: [{ name: "model", rawName: "v-model", value: _setup.checkedValues, expression: "checkedValues" }], class: [_setup.$style.BaseOptionInput, _setup.typeClass], attrs: { "id": _setup.uidInput, "disabled": _vm.disabled, "data-testid": _setup.formatTestId("input"), "aria-labelledby": _setup.uidLabel, "name": _vm.name, "tabindex": _vm.preventFocus ? -1 : 0, "type": "checkbox" }, domProps: { "value": _vm.value, "checked": Array.isArray(_setup.checkedValues) ? _vm._i(_setup.checkedValues, _vm.value) > -1 : _setup.checkedValues }, on: { "change": function($event) {
    var $$a = _setup.checkedValues, $$el = $event.target, $$c = $$el.checked ? true : false;
    if (Array.isArray($$a)) {
      var $$v = _vm.value, $$i = _vm._i($$a, $$v);
      if ($$el.checked) {
        $$i < 0 && (_setup.checkedValues = $$a.concat([$$v]));
      } else {
        $$i > -1 && (_setup.checkedValues = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
      }
    } else {
      _setup.checkedValues = $$c;
    }
  } } }, "input", _vm.$attrs, false), _setup.v2Listeners)) : _setup.inputType === "radio" ? _c("input", _vm._g(_vm._b({ directives: [{ name: "model", rawName: "v-model", value: _setup.checkedValues, expression: "checkedValues" }], class: [_setup.$style.BaseOptionInput, _setup.typeClass], attrs: { "id": _setup.uidInput, "disabled": _vm.disabled, "data-testid": _setup.formatTestId("input"), "aria-labelledby": _setup.uidLabel, "name": _vm.name, "tabindex": _vm.preventFocus ? -1 : 0, "type": "radio" }, domProps: { "value": _vm.value, "checked": _vm._q(_setup.checkedValues, _vm.value) }, on: { "change": function($event) {
    _setup.checkedValues = _vm.value;
  } } }, "input", _vm.$attrs, false), _setup.v2Listeners)) : _c("input", _vm._g(_vm._b({ directives: [{ name: "model", rawName: "v-model", value: _setup.checkedValues, expression: "checkedValues" }], class: [_setup.$style.BaseOptionInput, _setup.typeClass], attrs: { "id": _setup.uidInput, "disabled": _vm.disabled, "data-testid": _setup.formatTestId("input"), "aria-labelledby": _setup.uidLabel, "name": _vm.name, "tabindex": _vm.preventFocus ? -1 : 0, "type": _setup.inputType }, domProps: { "value": _vm.value, "value": _setup.checkedValues }, on: { "input": function($event) {
    if ($event.target.composing) return;
    _setup.checkedValues = $event.target.value;
  } } }, "input", _vm.$attrs, false), _setup.v2Listeners)), _c("label", { class: [_setup.$style.BaseOptionLabel, _setup.directionClass], attrs: { "id": _setup.uidLabel, "for": _setup.uidInput, "aria-hidden": "true", "data-testid": _setup.formatTestId() } }, [_c("div", { class: _setup.$style.BaseOptionBox }), _vm.$slots.default ? _c("span", { class: _setup.$style.BaseOptionText, attrs: { "data-testid": _setup.formatTestId("label") } }, [_vm._t("default")], 2) : _vm._e()])]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const SingleInput = __component__.exports;
export {
  SingleInput as S,
  modelPropName as a,
  baseProps as b,
  changeEvent as c,
  emits as e,
  getItemsWithDefaultKeys as g,
  model as m,
  types as t,
  useItemsCustomKeysProps as u
};
